import LedgerTransactionsTable from './components/LedgerTransactionsTable';
import UseAccountStore from '../../../stores/DataStore';
import React, {useEffect} from 'react';
import UseLedgerStore from '../../../stores/LedgerStore';
import Spinner from '../../../components/spinner';
import Widget from '../../../components/widget/Widget';
import {HiOutlineCash} from 'react-icons/hi';
import {defaultDateFormatStr, formatCurrency} from '../../../stores/JSHelper';

const Ledger = () => {
  const {loading, refresh, walletResponse, downloadAccountStatement, psp, setPsp} = UseLedgerStore();
  const {account} = UseAccountStore();

  useEffect(() => {
    (async () => {
      await refresh();
    })();
  }, [account]);

  if (loading) {
    return <Spinner />;
  }
  const widgets = [
    {title: 'Start Date', subtitle: `${defaultDateFormatStr(walletResponse.startDate)}`},
    {title: 'End Date', subtitle: `${defaultDateFormatStr(walletResponse.endDate)}`},
    {title: 'Opening Balance', subtitle: `${formatCurrency(walletResponse.openingBalance, 'INR')}`},
    {title: 'Closing Balance', subtitle: `${formatCurrency(walletResponse.closingBalance, 'INR')}`},
    {title: 'Total Credit', subtitle: `${formatCurrency(walletResponse.totalCredit, 'INR')}`},
    {title: 'Total Debit', subtitle: `${formatCurrency(walletResponse.totalDebit, 'INR')}`},
    {title: 'Credit Count', subtitle: `${walletResponse.creditCount}`},
    {title: 'Debit Count', subtitle: `${walletResponse.debitCount}`},
  ];

  return (
    <div>
      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4 2xl:grid-cols-4 3xl:grid-cols-6">
        {widgets.map((d) => {
          return <Widget icon={<HiOutlineCash className="h-7 w-7" />} title={d.title} subtitle={d.subtitle} />;
        })}
      </div>


      <div className="my-5">
        <div>
          <LedgerTransactionsTable 
          transactions={walletResponse.transactions.reverse()} 
          refresh={refresh} 
          downloadAccountStatement={downloadAccountStatement}
          psp={psp}
          setPsp={setPsp}
          />
        </div>
      </div>
    </div>
  );
};

export default Ledger;
